export default __webpack_public_path__ + "static/media/woman_carrying_car_above_head_landingpage_284x227.4f6675ef.svg";